import SkeletonLoadingView from "../../../../components/SkeletonLoadingView/SkeletonLoadingView"
import "./SectionSelector.css"
import { SectionSelectorProps } from "./SectionSelector.types"

const SectionSelector = (props: SectionSelectorProps) => {

  const { sections, selectedSection, onSelect, isLoading } = props

  return (
    <div className="section-selector-container">
      {sections.map((section, key) => (
        <p 
          key={key} 
          className={selectedSection === key ? "section-label selected-section" : "section-label"}
          onClick={() => onSelect(key)}
        >
          {`Section ${section+1}`}
        </p>
      ))}
      {isLoading && (
        <SkeletonLoadingView style={{ width: "8em", height: "100%"}} />
      )}
    </div>
  )
}

export default SectionSelector